module.exports = __webpack_public_path__ + "media/5.67ac34cc.mp3";